import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, GiftIcon } from 'lucide-react';
interface OfferItemProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  value: string;
  delay: number;
}
function OfferItem({
  icon,
  title,
  description,
  value,
  delay
}: OfferItemProps) {
  return <motion.div initial={{
    opacity: 0,
    x: -20
  }} whileInView={{
    opacity: 1,
    x: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.5,
    delay
  }} className="flex gap-4 items-start" data-id="element-126">
      <div className="flex-shrink-0 text-amber-500 mt-1" data-id="element-127">{icon}</div>
      <div className="flex-1" data-id="element-128">
        <h4 className="font-bold text-lg mb-1" data-id="element-129">{title}</h4>
        <p className="text-gray-400 text-sm mb-2" data-id="element-130">{description}</p>
        <span className="text-amber-400 font-semibold" data-id="element-131">(Valor: {value})</span>
      </div>
    </motion.div>;
}
export function OfferSection() {
  return <section className="py-20 px-4 bg-gradient-to-b from-transparent to-black/40" data-id="element-132">
      <div className="max-w-4xl mx-auto" data-id="element-133">
        <motion.h2 initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-black text-center mb-12" data-id="element-134">
          ESTO ES TODO LO QUE RECIBES HOY:
        </motion.h2>

        <div className="bg-gradient-to-br from-gray-900 to-black border-2 border-amber-500/50 rounded-2xl p-8 shadow-2xl" data-id="element-135">
          <div className="space-y-6" data-id="element-136">
            <OfferItem icon={<BookOpenIcon className="w-8 h-8" data-id="element-138" />} title='📘 Sistema "The AI Goldmine"' description="El manual paso a paso para procesar servicios premium en minutos." value="$147" delay={0} data-id="element-137" />
            <div className="border-t border-gray-700" data-id="element-139" />
            <OfferItem icon={<GiftIcon className="w-8 h-8" data-id="element-141" />} title="🎁 Bonus 1: The Client Crusher" description="Los guiones exactos para conseguir clientes en USA hoy." value="$97" delay={0.1} data-id="element-140" />
            <div className="border-t border-gray-700" data-id="element-142" />
            <OfferItem icon={<GiftIcon className="w-8 h-8" data-id="element-144" />} title="🎁 Bonus 2: Prompt Vault Pro" description="Nuestra librería secreta de comandos para que la IA haga magia." value="$67" delay={0.2} data-id="element-143" />
            <div className="border-t border-gray-700" data-id="element-145" />
            <OfferItem icon={<GiftIcon className="w-8 h-8" data-id="element-147" />} title="🎁 Bonus 3: Invoice & Contract Vault" description="Documentos listos para cobrar y protegerte." value="$47" delay={0.3} data-id="element-146" />
            <div className="border-t border-gray-700" data-id="element-148" />
            <OfferItem icon={<GiftIcon className="w-8 h-8" data-id="element-150" />} title="🎁 Bonus 4: 7-Day Fast Cash Plan" description="La hoja de ruta para ganar dinero en tu primera semana." value="$97" delay={0.4} data-id="element-149" />
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.5
        }} className="mt-8 pt-6 border-t-2 border-amber-500/50 text-center" data-id="element-151">
            <p className="text-gray-400 text-lg mb-2" data-id="element-152">VALOR TOTAL:</p>
            <p className="text-5xl font-black text-amber-400" data-id="element-153">$455</p>
          </motion.div>
        </div>
      </div>
    </section>;
}